/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CompetenceLangViewModelPaginatedResponse } from "../types/CompetenceLangViewModelPaginatedResponse.ts";
import { competenceLangViewModelSchema } from "./competenceLangViewModelSchema.ts";

export const competenceLangViewModelPaginatedResponseSchema = z.object({
  data: z.array(z.lazy(() => competenceLangViewModelSchema)).nullish(),
  currentPage: z.optional(z.number().int()),
  totalPages: z.optional(z.number().int()),
  totalCount: z.optional(z.number().int()),
}) as unknown as ToZod<CompetenceLangViewModelPaginatedResponse>;
